import React from "react";
import "./Slider_CTA_UI.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {insertHtml} from "../../utils/dom";

class SliderCTAUI extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            slideIndex: 0,
            updateCount: 0
        }
    };

    componentRender(data) {

        let finalArray = data.slides;
        if (data.slides.length < 3) {
            for (let i = 0; i < 3 - data.slides.length; ++i) {
                finalArray = finalArray.concat(finalArray);
            }
        }

        const settings = {
            className: "center",
            centerMode: true,
            infinite: true,
            centerPadding: "80px",
            slidesToShow: 2,
            speed: 100,
            swipeToSlide: true,
            dots: true,
            arrows: true,
            cssEase: "linear",
            afterChange: (index) => this.setState(state => ({ slideIndex: state.updateCount + (index + 0) })),
            beforeChange: (current, next) => this.setState({ slideIndex: next })
        };

        return (
            <div id="slider-cta-ui">
                <div className="container-fluid external">
                    <div className="row background">
                        <div className="container-fluid external">
                            <div className="row">
                                <div className="col-12 container-extra-large">
                                    <div className="slider-cta-ui-container">
                                        <Slider ref={slider => (this.slider = slider)} {...settings}>
                                            {finalArray.map((item, index) => (
                                                <div key={index}
                                                     className="img-container">
                                                    <img src={item.image} alt="Luiss.it" className="slider-cta-image"/>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                    <div className="title">{finalArray[this.state.slideIndex].title}</div>
                                    <div className="subtitle" {...insertHtml(finalArray[this.state.slideIndex].content)}></div>
                                    <a href={finalArray[this.state.slideIndex].url}><button className="text-btn">{finalArray[this.state.slideIndex].cta}</button></a>
                                    <div className="shadow-left"></div>
                                    <div className="shadow-right"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SliderCTAUI;
